export enum InferenceChatTargetType
{
    Model = "model",
    LoadBalancer = "load/balancer",
    Failover = "failover",
    Race = "race",
    Router = "router",
    Gateway = "gateway"
}

export class InferenceRoutes
{
    static Home: string = "/";
    // Dashboard
    static Dashboard: string = "/dashboard";
    // Model
    static ModelList: string = "/model/list";
    static ModelNew: string = "/model/new";
    static ModelView(id: string) { return `/model/${id}/view`; }
    static ModelEdit(id: string) { return `/model/${id}/edit`; }
    static ModelCopy(id: string) { return `/model/${id}/copy`; }
    // Load Balancer
    static LoadBalancerList: string = "/load/balancer/list";
    static LoadBalancerNew: string = "/load/balancer/new";
    static LoadBalancerView(id: string) { return `/load/balancer/${id}/view`; }
    static LoadBalancerEdit(id: string) { return `/load/balancer/${id}/edit`; }
    static LoadBalancerCopy(id: string) { return `/load/balancer/${id}/copy`; }
    // Failover
    static FailoverList: string = "/failover/list";
    static FailoverNew: string = "/failover/new";
    static FailoverView(id: string) { return `/failover/${id}/view`; }
    static FailoverEdit(id: string) { return `/failover/${id}/edit`; }
    static FailoverCopy(id: string) { return `/failover/${id}/copy`; }
    // Race
    static RaceList: string = "/race/list";
    static RaceNew: string = "/race/new";
    static RaceView(id: string) { return `/race/${id}/view`; }
    static RaceEdit(id: string) { return `/race/${id}/edit`; }
    static RaceCopy(id: string) { return `/race/${id}/copy`; }
    // Router
    static RouterList: string = "/router/list";
    static RouterNew: string = "/router/new";
    static RouterView(id: string) { return `/router/${id}/view`; }
    static RouterEdit(id: string) { return `/router/${id}/edit`; }
    static RouterCopy(id: string) { return `/router/${id}/copy`; }
    // Gateway
    static GatewayList: string = "/gateway/list";
    static GatewayNew: string = "/gateway/new";
    static GatewayView(id: string) { return `/gateway/${id}/view`; }
    static GatewayEdit(id: string) { return `/gateway/${id}/edit`; }
    static GatewayCopy(id: string) { return `/gateway/${id}/copy`; }
    // Classifier
    static ClassifierList: string = "/classifier/list";
    static ClassifierNew: string = "/classifier/new";
    static ClassifierView(id: string) { return `/classifier/${id}/view`; }
    static ClassifierEdit(id: string) { return `/classifier/${id}/edit`; }
    static ClassifierCopy(id: string) { return `/classifier/${id}/copy`; }
    // Validator
    static ValidatorList: string = "/validator/list";
    static ValidatorNew: string = "/validator/new";
    static ValidatorView(id: string) { return `/validator/${id}/view`; }
    static ValidatorEdit(id: string) { return `/validator/${id}/edit`; }
    static ValidatorCopy(id: string) { return `/validator/${id}/copy`; }
    // GuardRail
    static GuardRailList: string = "/guard/rail/list";
    static GuardRailNew: string = "/guard/rail/new";
    static GuardRailView(id: string) { return `/guard/rail/${id}/view`; }
    static GuardRailEdit(id: string) { return `/guard/rail/${id}/edit`; }
    static GuardRailCopy(id: string) { return `/guard/rail/${id}/copy`; }
    // Condition
    static ConditionList: string = "/condition/list";
    static ConditionNew: string = "/condition/new";
    static ConditionView(id: string) { return `/condition/${id}/view`; }
    static ConditionEdit(id: string) { return `/condition/${id}/edit`; }
    static ConditionCopy(id: string) { return `/condition/${id}/copy`; }
    // ConditionGroup
    static ConditionGroupList: string = "/condition/group/list";
    static ConditionGroupNew: string = "/condition/group/new";
    static ConditionGroupView(id: string) { return `/condition/group/${id}/view`; }
    static ConditionGroupEdit(id: string) { return `/condition/group/${id}/edit`; }
    static ConditionGroupCopy(id: string) { return `/condition/group/${id}/copy`; }
    // Memory
    static MemoryList: string = "/memory/list";
    static MemoryNew: string = "/memory/new";
    static MemoryView(id: string) { return `/memory/${id}/view`; }
    static MemoryEdit(id: string) { return `/memory/${id}/edit`; }
    static MemoryCopy(id: string) { return `/memory/${id}/copy`; }
    // Wiper
    static WiperList: string = "/wiper/list";
    static WiperNew: string = "/wiper/new";
    static WiperView(id: string) { return `/wiper/${id}/view`; }
    static WiperEdit(id: string) { return `/wiper/${id}/edit`; }
    static WiperCopy(id: string) { return `/wiper/${id}/copy`; }
    // Budget
    static BudgetList: string = "/budget/list";
    static BudgetNew: string = "/budget/new";
    static BudgetView(id: string) { return `/budget/${id}/view`; }
    static BudgetEdit(id: string) { return `/budget/${id}/edit`; }
    static BudgetCopy(id: string) { return `/budget/${id}/copy`; }
    // Knowledgebase
    static KnowledgebaseList: string = "/knowledgebase/list";
    static KnowledgebaseNew: string = "/knowledgebase/new";
    static KnowledgebaseView(id: string) { return `/knowledgebase/${id}/view`; }
    static KnowledgebaseEdit(id: string) { return `/knowledgebase/${id}/edit`; }
    static KnowledgebaseCopy(id: string) { return `/knowledgebase/${id}/copy`; }
    // KnowledgebaseItem
    static KnowledgebaseItemList: string = "/knowledgebase/item/list";
    static KnowledgebaseItemNew: string = "/knowledgebase/item/new";
    static KnowledgebaseItemView(id: string) { return `/knowledgebase/item/${id}/view`; }
    static KnowledgebaseItemEdit(id: string) { return `/knowledgebase/item/${id}/edit`; }
    static KnowledgebaseItemCopy(id: string) { return `/knowledgebase/item/${id}/copy`; }
    // Chat (List / View - read only)
    static ChatList: string = "/chat/list";
    static ChatView(id: string) { return `/chat/${id}/view`; }
    // Interaction (List / View - read only)
    static InteractionList: string = "/interaction/list";
    static InteractionView(id: string) { return `/interaction/${id}/view`; }
    // Chat Page (chat with model, load balancer, failover, or race)
    static Chat(target_type: InferenceChatTargetType, target_id: string, chat_id: string)
    {
        return `/${target_type}/${target_id}/chat/${chat_id}`;
    }
    static ChatNew(target_type: InferenceChatTargetType, target_id: string)
    {
        return InferenceRoutes.Chat(target_type, target_id, "new");
    }
    static ChatModel(model_id: string, chat_id: string) { return InferenceRoutes.Chat(InferenceChatTargetType.Model, model_id, chat_id); }
    static ChatModelNew(model_id: string) { return InferenceRoutes.ChatNew(InferenceChatTargetType.Model, model_id); }
    static ChatLoadBalancer(load_balancer_id: string, chat_id: string) { return InferenceRoutes.Chat(InferenceChatTargetType.LoadBalancer, load_balancer_id, chat_id); }
    static ChatLoadBalancerNew(load_balancer_id: string) { return InferenceRoutes.ChatNew(InferenceChatTargetType.LoadBalancer, load_balancer_id); }
    static ChatFailover(failover_id: string, chat_id: string) { return InferenceRoutes.Chat(InferenceChatTargetType.Failover, failover_id, chat_id); }
    static ChatFailoverNew(failover_id: string) { return InferenceRoutes.ChatNew(InferenceChatTargetType.Failover, failover_id); }
    static ChatRace(race_id: string, chat_id: string) { return InferenceRoutes.Chat(InferenceChatTargetType.Race, race_id, chat_id); }
    static ChatRaceNew(race_id: string) { return InferenceRoutes.ChatNew(InferenceChatTargetType.Race, race_id); }
    static ChatRouter(router_id: string, chat_id: string) { return InferenceRoutes.Chat(InferenceChatTargetType.Router, router_id, chat_id); }
    static ChatRouterNew(router_id: string) { return InferenceRoutes.ChatNew(InferenceChatTargetType.Router, router_id); }
    static ChatGateway(gateway_id: string, chat_id: string) { return InferenceRoutes.Chat(InferenceChatTargetType.Gateway, gateway_id, chat_id); }
    static ChatGatewayNew(gateway_id: string) { return InferenceRoutes.ChatNew(InferenceChatTargetType.Gateway, gateway_id); }
}